import React from "react";

export default function Content({ children }) {
    return (
        <div className="flex justify-center box-border">
            <div className="w-[1270px] max-w-full pt-[40px] pb-[50px] h-max">
                {children}
            </div>
        </div>
    );
}
